import React from 'react';
import { Popover as AntdPopover, PopoverProps } from 'antd';
import styled from '@emotion/styled';
import classes from './StyledPopover.module.scss';
const StyledPopover = styled(AntdPopover)``;

export const Popover = (props: PopoverProps) => {
  return (
    <StyledPopover
      overlayClassName={classes.overlay}
      {...props}
    ></StyledPopover>
  );
};
